<div class="hotel-modal modal-dialog modal-content p-0">
  <div class="modal-header p-4 border-bottom d-flex justify-content-between align-items-center">
    <h3 class="modal-title">
      {{ data.title }}
    </h3>
    <fa-icon icon="times" class="close-icon" (click)="bsModalRef?.hide()">&times;</fa-icon>
  </div>

  <div class="modal-body p-4 pt-3">
    <!-- Employee -->
    <div class="employee-info box">
      <h6 class="section-label">Employee</h6>
      <div class="d-flex align-items-center">
        <img src="https://i.pravatar.cc/40?u={{data.employee}}" class="employee-avatar me-2">
        <div>
          <p class="employee-name">
            {{ data.employee }}
          </p>
          <a href="mailto:{{data.email}}" class="employee-email">
            {{ data.email }}</a>
          </div>
      </div>
    </div>

    <!-- Booking ID and Status -->
    <div class="booking-id box border-top pt-3 d-flex justify-content-between align-items-start">
      <div>
        <h6 class="section-label">Booking ID</h6>
        <p class="section-value">
          {{ data.bookingId }}
        </p>
      </div>
      <span class="status-badge">
        {{ data.status }}</span>
    </div>

    <!-- Dynamic Fields -->
    <div *ngFor="let field of data.fields" class="boxinfo-field border-top pt-3">
      <h6 class="section-label">
        {{ field.label }}
      </h6>
      <p class="section-value">
        {{ field.value }}
      </p>
    </div>
    <div  class="boxinfo-field border-top pt-3">
      <h6 class="section-label">
        Extra Information
      </h6>
      <p class="section-value">
        {{ data.extraInfo }}
      </p>
    </div>
  </div>
</div>
